const stack = {
    stack: Promise.resolve(),
    push: function (asyncCallback) {
        this.stack = this.stack.then(asyncCallback, asyncCallback);
    }
};

export default stack;